// START: Robust Professional Welcome Popup Script
  document.addEventListener('DOMContentLoaded', function() {
    const popupModal = document.getElementById('WelcomePopupRefactored');
    const closeBtn = popupModal ? popupModal.querySelector('.popup-close-btn') : null;
    const storageKey = 'welcomePopupRefactored_v1'; // Unique key
    const delayMs = 2500; // 2.5 seconds

    // 1. Check LocalStorage
    const hasSeenPopup = localStorage.getItem(storageKey);

    // 2. Show Function
    function showPopup() {
      if (!popupModal) return;
      popupModal.style.display = 'flex'; // Ensure flex layout exists
      // Small timeout to allow CSS transition to catch the display change
      setTimeout(() => {
        popupModal.classList.add('is-visible');
      }, 10);
    }

    // 3. Close Function
    function closePopup() {
      if (!popupModal) return;
      popupModal.classList.remove('is-visible');
      
      // Wait for animation to finish before hiding display
      setTimeout(() => {
        popupModal.style.display = 'none';
      }, 300);
      
      localStorage.setItem(storageKey, 'true');
    }

    // 4. Trigger Logic
    if (!hasSeenPopup) {
      setTimeout(showPopup, delayMs);
    }

    // 5. Event Listeners
    if (closeBtn) {
      closeBtn.addEventListener('click', closePopup);
    }

    if (popupModal) {
      // Close on background click
      popupModal.addEventListener('click', function(e) {
        if (e.target === popupModal) {
          closePopup();
        }
      });
      
      // Close on Escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && popupModal.classList.contains('is-visible')) {
          closePopup();
        }
      });
    }
  });
  // END: Robust Professional Welcome Popup Script